import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UnitShort} from '@common-module/modelinterfaces/unit-short.model';
import {Unit} from '@common-module/modelinterfaces/unit.model';
import { DialogComponent } from '@common-module/dialog/dialog/dialog.component';
import { UnitViewFormComponent } from '../unit-view-form.component';
import { DialogContentDirective } from '@common-module/dialog/dialog/dialog-content.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-unit-view-dialog',
    templateUrl: './edit-unit-view-dialog.component.html',
    styleUrls: ['../../../../../../../../common-module/src/lib/app-styles/dialog-common.scss'],
    imports: [DialogComponent, UnitViewFormComponent, DialogContentDirective, TranslateModule]
})

export class EditUnitViewDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { unit: UnitShort | Unit }) {
  }
}
